import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = ["innerHTML"]

import type {
  CellDataOfStorageItem,
  TableDataCell,
} from "@/models/interfaces/entity-settings/querytable/querytable";
import SimpleCellElementLite from "./SimpleCellElementLite.vue";
import ParameterCellElementLite from "./ParameterCellElementLite.vue";
import ChangeDateCellElementLite from "./ChangeDateCellElementLite.vue";
import BillCellElementLite from "./BillCellElementLite.vue";
import EntityCellElementLite from "./EntityCellElementLite.vue";
import JobCellElementLite from "./JobCellElementLite.vue";
import TagCellElementLite from "./TagCellElementLite.vue";
import SourceItemsCellElementLite from "./SourceItemsCellElementLite.vue";
import { formatIconHtml } from "./cellFormat";


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonCellElementLite',
  props: {
    element: {},
    srcElement: {},
    entityId: {},
    creatorId: {},
    WA: { type: Boolean },
    columnIndex: {},
    hoveredParamRecId: {},
    noRowHeightAlign: { type: Boolean }
  },
  emits: ["refreshNeeded", "changeHoverRecord", "changeHeights", "sourceItemsRequested"],
  setup(__props: any) {

const props = __props;



/**
 * Разворачиваем складскую позицию в её внутренний элемент: данные лежат в ItemData,
 * а тип рендеринга - в собственном DisplayType позиции. Category и Minimized
 * наследуем от внешней ячейки, как делал старый рекурсивный рендер.
 */
function innerOf(gen_el: CellDataOfStorageItem): TableDataCell {
  return {
    Data: gen_el.ItemData,
    DisplayType: gen_el.DisplayType,
    Category: props.element.Category,
    Minimized: false,
  } as TableDataCell;
}

function iconHtml(cell: TableDataCell): string {
  return formatIconHtml(cell).join("<br/>");
}

return (_ctx: any,_cache: any) => {
  const _component_CommonCellElementLite = _resolveComponent("CommonCellElementLite", true)!

  return (_ctx.element.DisplayType === 16)
    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.element.Data, (gen_el, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: 'sub_' + i,
          class: "qtl-storage-sub"
        }, [
          (innerOf(gen_el).DisplayType === 0 || innerOf(gen_el).DisplayType === 6)
            ? (_openBlock(), _createBlock(SimpleCellElementLite, {
                key: 0,
                element: innerOf(gen_el),
                "entity-id": _ctx.entityId,
                "creator-id": _ctx.creatorId,
                onRefreshNeeded: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('refreshNeeded')))
              }, null, 8, ["element", "entity-id", "creator-id"]))
            : (innerOf(gen_el).DisplayType === 2)
              ? (_openBlock(), _createBlock(ParameterCellElementLite, {
                  key: 1,
                  element: innerOf(gen_el),
                  "table-row-number": _ctx.entityId,
                  "column-index": _ctx.columnIndex + '_' + i,
                  "hovered-param-rec-id": _ctx.hoveredParamRecId,
                  "no-row-height-align": _ctx.noRowHeightAlign,
                  onChangeHoverRecord: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('changeHoverRecord', $event))),
                  onChangeHeights: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('changeHeights', $event)))
                }, null, 8, ["element", "table-row-number", "column-index", "hovered-param-rec-id", "no-row-height-align"]))
              : (innerOf(gen_el).DisplayType === 7)
                ? (_openBlock(), _createBlock(ChangeDateCellElementLite, {
                    key: 2,
                    element: innerOf(gen_el)
                  }, null, 8, ["element"]))
                : (innerOf(gen_el).DisplayType === 12 || innerOf(gen_el).DisplayType === 15)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 3,
                      class: "qtl-icon-cell",
                      innerHTML: iconHtml(innerOf(gen_el))
                    }, null, 8, _hoisted_1))
                  : (innerOf(gen_el).DisplayType === 18)
                    ? (_openBlock(), _createBlock(BillCellElementLite, {
                        key: 4,
                        element: innerOf(gen_el)
                      }, null, 8, ["element"]))
                    : (innerOf(gen_el).DisplayType === 16)
                      ? (_openBlock(), _createBlock(_component_CommonCellElementLite, {
                          key: 5,
                          element: innerOf(gen_el),
                          "src-element": _ctx.srcElement,
                          "entity-id": _ctx.entityId,
                          "creator-id": _ctx.creatorId,
                          WA: _ctx.WA,
                          "column-index": _ctx.columnIndex + '_' + i,
                          "hovered-param-rec-id": _ctx.hoveredParamRecId,
                          "no-row-height-align": _ctx.noRowHeightAlign,
                          onRefreshNeeded: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('refreshNeeded'))),
                          onChangeHoverRecord: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('changeHoverRecord', $event))),
                          onChangeHeights: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('changeHeights', $event))),
                          onSourceItemsRequested: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('sourceItemsRequested', $event)))
                        }, null, 8, ["element", "src-element", "entity-id", "creator-id", "WA", "column-index", "hovered-param-rec-id", "no-row-height-align"]))
                      : ([1, 3, 4, 8, 11, 13, 14, 17].includes(innerOf(gen_el).DisplayType))
                        ? (_openBlock(), _createBlock(EntityCellElementLite, {
                            key: 6,
                            element: innerOf(gen_el)
                          }, null, 8, ["element"]))
                        : (innerOf(gen_el).DisplayType === 5 || innerOf(gen_el).DisplayType === 9)
                          ? (_openBlock(), _createBlock(JobCellElementLite, {
                              key: 7,
                              element: innerOf(gen_el)
                            }, null, 8, ["element"]))
                          : (innerOf(gen_el).DisplayType === 10)
                            ? (_openBlock(), _createBlock(TagCellElementLite, {
                                key: 8,
                                element: innerOf(gen_el),
                                "entity-id": _ctx.entityId,
                                onRefreshNeeded: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('refreshNeeded')))
                              }, null, 8, ["element", "entity-id"]))
                            : (innerOf(gen_el).DisplayType === 19)
                              ? (_openBlock(), _createBlock(SourceItemsCellElementLite, {
                                  key: 9,
                                  element: innerOf(gen_el),
                                  onSourceItemsRequested: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('sourceItemsRequested', $event)))
                                }, null, 8, ["element"]))
                              : (_openBlock(), _createBlock(SimpleCellElementLite, {
                                  key: 10,
                                  element: innerOf(gen_el),
                                  "entity-id": _ctx.entityId,
                                  "creator-id": _ctx.creatorId
                                }, null, 8, ["element", "entity-id", "creator-id"]))
        ]))
      }), 128))
    : _createCommentVNode("", true)
}
}

})